export const LIST_APPLICATIONS_ROUTE = 'wnioski';
export const DRAFT_LIST_APPLICATIONS_ROUTE = 'wnioski-robocze';
export const APPLICATION_PREVIEW = 'podglad/:id/:type'
